import { Pipe, PipeTransform } from '@angular/core';
import { arrayNotEmpty } from 'src/app/utils/array.utils';

@Pipe({
    name: 'exclude',
    standalone: false
})
export class ExcludePipe implements PipeTransform {

  transform(list: any, ...args: any[]): any {
      const property = args[0];
      const values = args[1];

      return arrayNotEmpty(values) ? list.filter(e => values.indexOf(e[property]) === -1) : list;
  }

}
